<template>
  <div>
    <el-form
      ref="KeyFrom"
      :model="SetIndexUrlMod"
      label-position="left"
      label-width="60px"
      size="mini"
    >
      <el-form-item
        v-for="(item, index) in SetIndexUrlMod.ExitUrls"
        :label="'链接' + index"
        prop="ExitUrls"
        :key="index"
      >
        <el-row :gutter="5">
          <el-col :span="22">
            <el-input v-model="item.indexUrl" @blur="handleUrlBlur(item)">
              <template slot="prepend">https://www.douyin.com/user/</template>
              <template slot="append">?from_tab_name=main</template>
            </el-input>
          </el-col>
          <el-col :span="1">
            <el-button
              icon="el-icon-delete-solid"
              @click="DelUrlLink(index)"
            ></el-button>
          </el-col>
        </el-row>
      </el-form-item>

      <el-form-item label="">
        <el-button type="info" @click="AddUrlItem">添加一条链接</el-button>
      </el-form-item>

      <el-form-item label="">
        <el-button type="primary" @click="EditComHandle('KeyFrom')"
          >确定</el-button
        >
        <el-button @click="CancleEdit">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { getUserIndexUrls, setUserIndexUrls } from "@/api/showbiz";
export default {
  data() {
    return {
      SetIndexUrlMod: {
        SelKeyWordId: "",
        ExitUrls: [],
      },
    };
  },
  methods: {
    GetKeyDefaultUrls(id) {
      this.SetIndexUrlMod.SelKeyWordId = id;
      getUserIndexUrls(id).then((res) => {
        console.log(res);
        if (res.code === 0) {
          this.SetIndexUrlMod.ExitUrls = Object.assign(res.data);
        }

        if (this.SetIndexUrlMod.ExitUrls.length == 0) {
          this.SetIndexUrlMod.ExitUrls.push({
            id: "",
            indexUrl: "",
          });
        }
      });
    },
    AddUrlItem() {
      this.SetIndexUrlMod.ExitUrls.push({
        id: "",
        indexUrl: "",
      });
    },
    DelUrlLink(index) {
      this.SetIndexUrlMod.ExitUrls.splice(index, 1);
    },
    EditComHandle() {
      setUserIndexUrls(
        this.SetIndexUrlMod.SelKeyWordId,
        this.SetIndexUrlMod.ExitUrls.map((item) => item.indexUrl)
      ).then((res) => {
        console.log(res);
        if (res.code === 0) {
          this.$message.success(res.msg);
          this.$emit("EditComHandle");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    CancleEdit() {
      this.$emit("EditComHandle");
    },
    handleUrlBlur(item) {
      if (item.indexUrl) {
        let url = item.indexUrl.trim();
        // 处理完整的抖音链接
        if (url.includes('https://www.douyin.com/user/')) {
          // 提取用户ID部分
          let match = url.match(/https:\/\/www\.douyin\.com\/user\/([^?]+)/);
          if (match && match[1]) {
            item.indexUrl = match[1];
          }
        } else if (url.includes('?')) {
          // 处理带有查询参数的情况
          item.indexUrl = url.split('?')[0];
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>